import Alert, { AlertColor } from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import Badge from '@mui/material/Badge'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { GridCellParams } from '@/global/components/DataGrid/utils/types'
import dayjs from 'dayjs'
import Menu from 'global/components/MenuV2'
import React from 'react'
import { LogCalculos } from 'service/api'

const notificacoes = (row: any) => {
    if (!row)
        return {
            quantidade: 0,
        }
    const logsLength = row.logs?.length ?? 0
    const hasFeriado = Boolean(row.feriado)
    const n = hasFeriado ? logsLength + 1 : logsLength
    let res = n
    if (row.logs?.find((log: any) => log.titulo === 'Admissão'))
        res = n - 1 > 0 ? n - 1 + ' A' : 'A'
    if (row.logs?.find((log: any) => log.titulo === 'Rescisão'))
        res = n - 1 > 0 ? n - 1 + ' R' : 'R'
    return {
        quantidade: n,
        texto: res,
    }
}

export const ExibirDia: React.FC<GridCellParams> = ({ row, value }) => {
    const Display = (
        <Box
            title={
                row.feriado ? `Feriado ${row.feriado.nome ?? ''}` : undefined
            }
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-evenly',
                height: 'fit-content',
            }}
        >
            <Typography
                variant="body2"
                sx={{ lineHeight: 1, textTransform: 'uppercase' }}
            >
                {dayjs(value).format('ddd')}
            </Typography>

            <Typography
                variant="body2"
                sx={{ lineHeight: 1, fontWeight: 'bold' }}
            >
                {dayjs(value).format('DD/MM')}
            </Typography>
        </Box>
    )

    return (
        <Box
            sx={{
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                overflow: 'visible',
            }}
        >
            <Badge
                badgeContent={
                    notificacoes(row).quantidade > 0 ? (
                        <span
                            onClick={() => {
                                const el = document.getElementById(
                                    `badge-${row.id}`,
                                )?.parentElement?.parentElement
                                    ?.firstElementChild?.firstElementChild

                                el?.dispatchEvent(
                                    new MouseEvent('click', {
                                        view: window,
                                        bubbles: true,
                                        cancelable: true,
                                    }),
                                )
                            }}
                            style={{
                                cursor: 'pointer',
                            }}
                            id={`badge-${row.id}`}
                        >
                            {notificacoes(row).texto}
                        </span>
                    ) : null
                }
                color={getColor(row, true) as any}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                sx={{
                    height: '100%',
                    justifyContent: 'center',
                    display: 'flex',
                    alignItems: 'center',
                    '& .MuiBadge-badge': {
                        top: '0.75rem !important',
                    },
                }}
            >
                {notificacoes(row).quantidade > 0 ? (
                    <Menu.Root position="left">
                        <Menu.Trigger pointer>{Display}</Menu.Trigger>
                        <Menu.List
                            elevation={1}
                            sx={{
                                '& .MuiList-root': {
                                    padding: 0,
                                },
                            }}
                        >
                            {row.feriado && (
                                <Alert
                                    sx={{
                                        minWidth: 400,
                                    }}
                                    severity="info"
                                >
                                    <AlertTitle>Feriado</AlertTitle>
                                    {row.feriado.nome}
                                </Alert>
                            )}
                            {row.logs?.map((log: LogCalculos, i: number) => (
                                <Alert
                                    severity={getColor({ logs: [log] })}
                                    key={i}
                                >
                                    <AlertTitle>
                                        {(log as any).titulo}
                                    </AlertTitle>
                                    {log.descricao}
                                </Alert>
                            ))}
                        </Menu.List>
                    </Menu.Root>
                ) : (
                    Display
                )}
            </Badge>
        </Box>
    )
}

function getColor(row: any): AlertColor | undefined
function getColor(row: any, badge: true): string | undefined
function getColor(row: any, badge?: boolean): AlertColor | undefined | string {
    if (row.logs?.length) {
        if (row.logs.some((log: LogCalculos) => log.variante === 'error'))
            return 'error'
        if (row.logs.some((log: LogCalculos) => log.variante === 'warning'))
            return 'warning'
        if (row.logs.some((log: LogCalculos) => log.titulo === 'Rescisão')) {
            return badge ? 'primary' : 'info'
        }
        if (row.logs.some((log: LogCalculos) => log.variante === 'info'))
            return 'info'
        if (row.logs.some((log: LogCalculos) => log.variante === 'success'))
            return 'success'
    } else if (row.feriado) return 'info'

    return undefined
}
